// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Background */
.screening-section {
  background: #425151;
  padding: 60px 30px;
  color: white;
  min-height: 100vh;
  font-family: "Inter", sans-serif;
}

/* Title */
.screening-title {
  text-align: center;
  font-size: 3rem;
  font-weight: 400;
  color: #FFE600;
  margin-top: 20px;
}

.screening-subtitle {
  text-align: center;
  font-size: 1.2rem;
  opacity: 0.9;
  margin-bottom: 40px;
}

/* Section Label */
.section-label {
  color: #FFE600;
  margin-top: 40px;
  font-size: 1.8rem;
  margin-bottom: 20px;
}

/* Grid */
.screening-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 26px;
  margin-bottom: 50px;
}

/* Modern Program Card */
.program-card {
  background: #ffffff10;
  border-radius: 12px;
  padding: 0 0 20px 0;
  cursor: pointer;
  transition: 0.3s ease;
  backdrop-filter: blur(8px);
}

.program-card:hover {
  transform: translateY(-6px);
  background: #ffffff22;
}

/* Image */
.program-image {
 width: 100%;
  height: 180px;
  object-fit: cover;   /* <<< KEY FIX */
  background: #ffffff;
  border-bottom: 3px solid #FFE600;
  border-radius: 12px 12px 0 0;
  object-position: center;
}

/* Title */
.program-title {
  font-size: 1.25rem;
  margin: 16px 20px 8px;
  text-decoration: underline;
  color: white;
  font-weight: 500;
}

/* Short text */
.program-short {
  color: #e0e7e7;
  font-size: 0.95rem;
  margin: 0 20px;
  line-height: 1.5;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: #00000080;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-box {
  background: #ffffff;
  width: 90%;
  max-width: 600px;
  padding: 25px;
  border-radius: 14px;
  color: #425151;
}

.modal-img {
  width: 100%;
  height: 180px;
  object-fit: contain;
  margin-bottom: 15px;
}

.modal-title {
  font-size: 1.6rem;
  margin-bottom: 12px;
}

.modal-list li {
  margin-bottom: 6px;
  line-height: 1.5;
}

.modal-close {
  margin-top: 20px;
  padding: 10px 22px;
  background: #425151;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
@media (max-width: 768px) {
  .screening-title {
    margin-top: 60px;
  }
  .modal-box {
    margin-top: 100px;
   
  }
}
@media (max-width: 600px) {
  .screening-title {
    margin-top: 60px;
  }
 .modal-box {
    margin-top: 200px;
    max-width: fit-content;
    max-height: fit-content;
    /* max-width: 380px;
    padding: 18px; */
  }

}
@media (max-width: 480px) {
  .modal-box {
    width: 95%;
    max-height: 92vh;
    padding-bottom: 80px;     /* space for sticky button */
  }

  .modal-close {
    font-size: 1rem;
    padding: 12px;
  }
}
@media (max-width: 375px) {
  .modal-box {
    width: 94% !important;
    max-height: 88vh !important;
    padding: 16px 0 80px !important; /* space for button */
    border-radius: 12px !important;
    overflow-y: auto !important;
  }
.modal-title {
    font-size: 1.05rem !important;
    padding: 0 16px !important;
    line-height: 1.3 !important;
  }

  /* Description text */
  .modal-text {
    font-size: 0.90rem !important;
    padding: 0 16px !important;
    line-height: 1.45 !important;
  }
 .modal-close {
    position: relative !important;
    /* bottom: 0 !important; */
    left: 30px;
    width: 50% !important;
    background: #425151 !important;
    color: #FFE600 !important;
    padding: 12px 0 !important;
    font-size: 1rem !important;
    border-radius: 0 0 12px 12px !important;
    margin-top: 10px !important;
    z-index: 50 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/PAGES/SCREENING/SECTIONS/SCREENING_PROGRAM/index.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,UAAU;AACV;CACC,WAAW;EACV,aAAa;EACb,iBAAiB,IAAI,gBAAgB;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;;EAEnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;CACD;IACG,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB;oBACgB;EAClB;;AAEF;AACA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,oBAAoB,MAAM,4BAA4B;EACxD;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;AACA;EACE;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,+BAA+B,EAAE,qBAAqB;IACtD,8BAA8B;IAC9B,2BAA2B;EAC7B;AACF;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,qBAAqB;EACrB;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,4BAA4B;EAC9B;CACD;IACG,6BAA6B;IAC7B,0BAA0B;IAC1B,UAAU;IACV,qBAAqB;IACrB,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,uCAAuC;IACvC,2BAA2B;IAC3B,sBAAsB;EACxB;AACF","sourcesContent":["/* Background */\n.screening-section {\n  background: #425151;\n  padding: 60px 30px;\n  color: white;\n  min-height: 100vh;\n  font-family: \"Inter\", sans-serif;\n}\n\n/* Title */\n.screening-title {\n  text-align: center;\n  font-size: 3rem;\n  font-weight: 400;\n  color: #FFE600;\n  margin-top: 20px;\n}\n\n.screening-subtitle {\n  text-align: center;\n  font-size: 1.2rem;\n  opacity: 0.9;\n  margin-bottom: 40px;\n}\n\n/* Section Label */\n.section-label {\n  color: #FFE600;\n  margin-top: 40px;\n  font-size: 1.8rem;\n  margin-bottom: 20px;\n}\n\n/* Grid */\n.screening-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 26px;\n  margin-bottom: 50px;\n}\n\n/* Modern Program Card */\n.program-card {\n  background: #ffffff10;\n  border-radius: 12px;\n  padding: 0 0 20px 0;\n  cursor: pointer;\n  transition: 0.3s ease;\n  backdrop-filter: blur(8px);\n}\n\n.program-card:hover {\n  transform: translateY(-6px);\n  background: #ffffff22;\n}\n\n/* Image */\n.program-image {\n width: 100%;\n  height: 180px;\n  object-fit: cover;   /* <<< KEY FIX */\n  background: #ffffff;\n  border-bottom: 3px solid #FFE600;\n  border-radius: 12px 12px 0 0;\n  object-position: center;\n}\n\n/* Title */\n.program-title {\n  font-size: 1.25rem;\n  margin: 16px 20px 8px;\n  text-decoration: underline;\n  color: white;\n  font-weight: 500;\n}\n\n/* Short text */\n.program-short {\n  color: #e0e7e7;\n  font-size: 0.95rem;\n  margin: 0 20px;\n  line-height: 1.5;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background: #00000080;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.modal-box {\n  background: #ffffff;\n  width: 90%;\n  max-width: 600px;\n  padding: 25px;\n  border-radius: 14px;\n  color: #425151;\n}\n\n.modal-img {\n  width: 100%;\n  height: 180px;\n  object-fit: contain;\n  margin-bottom: 15px;\n}\n\n.modal-title {\n  font-size: 1.6rem;\n  margin-bottom: 12px;\n}\n\n.modal-list li {\n  margin-bottom: 6px;\n  line-height: 1.5;\n}\n\n.modal-close {\n  margin-top: 20px;\n  padding: 10px 22px;\n  background: #425151;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n@media (max-width: 768px) {\n  .screening-title {\n    margin-top: 60px;\n  }\n  .modal-box {\n    margin-top: 100px;\n   \n  }\n}\n@media (max-width: 600px) {\n  .screening-title {\n    margin-top: 60px;\n  }\n .modal-box {\n    margin-top: 200px;\n    max-width: fit-content;\n    max-height: fit-content;\n    /* max-width: 380px;\n    padding: 18px; */\n  }\n\n}\n@media (max-width: 480px) {\n  .modal-box {\n    width: 95%;\n    max-height: 92vh;\n    padding-bottom: 80px;     /* space for sticky button */\n  }\n\n  .modal-close {\n    font-size: 1rem;\n    padding: 12px;\n  }\n}\n@media (max-width: 375px) {\n  .modal-box {\n    width: 94% !important;\n    max-height: 88vh !important;\n    padding: 16px 0 80px !important; /* space for button */\n    border-radius: 12px !important;\n    overflow-y: auto !important;\n  }\n.modal-title {\n    font-size: 1.05rem !important;\n    padding: 0 16px !important;\n    line-height: 1.3 !important;\n  }\n\n  /* Description text */\n  .modal-text {\n    font-size: 0.90rem !important;\n    padding: 0 16px !important;\n    line-height: 1.45 !important;\n  }\n .modal-close {\n    position: relative !important;\n    /* bottom: 0 !important; */\n    left: 30px;\n    width: 50% !important;\n    background: #425151 !important;\n    color: #FFE600 !important;\n    padding: 12px 0 !important;\n    font-size: 1rem !important;\n    border-radius: 0 0 12px 12px !important;\n    margin-top: 10px !important;\n    z-index: 50 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
